import {Routes, Route, BrowserRouter} from 'react-router-dom';

import {PrivateRoute} from './PrivateRoute';
import {PublicRoute} from './PublicRoute';

import {LoginPage} from '../pages/login/LoginPage';
import {MainRoutes} from "./MainRoutes";
import {AppContext} from "../context/appContext";
import {checkSession} from "../api/auth.service";
import {types} from "../shared/types/types";
import React, {useContext, useEffect} from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import AdminNavbar from "../components/Navbars/AdminNavbar.js";
import HeaderStats from "../components/Headers/HeaderStats";

import {Loader} from "../components/Loader/Loader";


export const AppRouter = () => {

    const { user,dispatch} = useContext(AppContext);

    useEffect(() => {
        async function fetchData() {
            const response = await checkSession();
            const data = await response.data;
            let login = false;
            let nombre = "";
            if (parseInt(data.estado) === 200) {
                login = true;
                nombre = data.data;
            }

            const action = {
                type: types.authTrue,
                payload: {login, nombre}
            }

            dispatch(action)

        }

       fetchData().then(r => true);

    }, [dispatch]);
    return (
        <>
            <Loader show={user.load} />
            <BrowserRouter>
                <Routes>
                    <Route path="/login" exact element={
                        <PublicRoute>
                            <main>
                                <section className="relative w-full h-full py-40 min-h-screen">
                                    <div
                                        className="absolute top-0 w-full h-full bg-lightBlue-800 bg-no-repeat bg-full"
                                        style={{
                                            backgroundImage:
                                                "url(/img/fondo-toa.jpg)",
                                        }}
                                    />
                                    <LoginPage/>
                                </section>
                            </main>
                        </PublicRoute>
                    }
                    />


                    <Route path="/*" element={
                        <PrivateRoute>
                            <Sidebar/>
                            <div className="relative md:ml-4 bg-blueGray-100">
                                <AdminNavbar/>
                                <HeaderStats/>
                                <div className="px-4 md:px-10 mx-auto w-full -m-24">
                                    <MainRoutes/>
                                </div>
                            </div>
                        </PrivateRoute>
                    }
                    />

                    {/* <Route path="/*" element={ <DashboardRoutes />  } /> */}
                </Routes>
            </BrowserRouter>
        </>

    )
}
